import React, { useContext, useEffect } from "react";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import ContactFitler from "components/filters/Filters/ContactFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import VenueFilter from "components/filters/Filters/VenueFilter";
import AppointmentPhaseFilter from "components/filters/Filters/AppointmentPhaseFilter";
import AppointmentTypeFilter from "components/filters/Filters/AppointmentTypeFilter";
import QuarterFilter from "components/filters/Filters/QuarterFilter";
import { FilterContext } from "components/filters/FilterContext";
import { PlanningContext } from "PlanningContext/PlanningContext";

interface QuarterFilterProps {
  external?: boolean;
}

export const QuarterFilters = (props: QuarterFilterProps) => {
  const filterContext = useContext(FilterContext);
  const planningContext = useContext(PlanningContext);

  const artist = filterContext.getValue("artist");

  useEffect(() => {
    planningContext.setOpts({
      artist: artist.selectedArtists.length > 0 ? artist.selectedArtists[0] : undefined,
    });
  }, [artist]);


  return <>
    <ArtistFilter />
    {!props.external && <ContactFitler />}
    <ProductionFilter />
    {(site.currentEnvironment.venueFilterInMonthViewEnabled && site.permissions.addressBook.canAccess) && <VenueFilter />}
    <AppointmentPhaseFilter />
    <AppointmentTypeFilter />
    <QuarterFilter />
  </>;
};
